import { useState } from "react";
import { trpc } from "../../../utils/trpc";
import { RouterInferenceHelpers } from "../../../../../../src/api/trpc/rootRouter";
import { SeshPrimaryButton } from "../base_components/sesh_primary_button";
import { DateTimePicker } from "../../date_time_picker";
import {
	createRRuleSet,
	isTimeBetweenRepeats,
	RDateDescriptor,
} from "../../../../../../common/repeat_utils";
import { ModifySettingsButton } from "../base_components/modify_settings_button";

export function EditEventTimeContent(props: {
	rrule: string;
	repeat_start_time: Date;
	original_instance_start_time: Date;
	start_time: Date;
	end_time: Date;
	repeat_tz: string;
	exdates: string[];
	rdates: RDateDescriptor[];
	is_loading?: boolean;
	onSubmit: (date: Date) => void;
	onBack?: () => void;
}) {
	const [time, setTime] = useState(new Date(props.start_time));

	// const rrule_set = createRRuleSet({
	// 	rrule_str: props.event.rrule,
	// 	start_time_js: new Date(
	// 		props.event.repeat_instance_original_start_time_str
	// 	),
	// 	repeat_tz: props.event.repeat_tz,
	// 	exdates: props.event.exdates,
	// 	rdates: props.event.rdates,
	// });

	const rrule_set = createRRuleSet({
		rrule_str: props.rrule,
		start_time_js: props.repeat_start_time,
		repeat_tz: props.repeat_tz,
		exdates: props.exdates,
		rdates: props.rdates,
	});

	const duration_ms = props.end_time.getTime() - props.start_time.getTime();

	const is_valid_time = isTimeBetweenRepeats(
		rrule_set,
		new Date(props.original_instance_start_time),
		props.start_time,
		time,
		duration_ms
	);

	return (
		<div className="mt-4 flex flex-col gap-4">
			<DateTimePicker
				disable_past_days
				initial_value={time}
				updateFunc={(val) => setTime(new Date(val))}
				disabled={false}
			/>
			<div className="ml-auto flex w-fit items-center gap-2">
				{!is_valid_time && (
					<div className="text-sm text-warning">
						Start time must be between subsequent and previous
						repeats
					</div>
				)}
				<div className="ml-auto flex w-fit gap-4">
					{props.onBack && (
						<ModifySettingsButton hide_arrow onClick={props.onBack}>
							Back
						</ModifySettingsButton>
					)}
					<SeshPrimaryButton
						disabled={!is_valid_time}
						onClick={() => props.onSubmit(time)}
						is_loading={props.is_loading}
					>
						Edit
					</SeshPrimaryButton>
				</div>
			</div>
		</div>
	);
}
